<mat-dialog-actions  class="dark-bg p-3 dark-mode d-flex justify-content-between">

    <h3 style="font-size: 23px; color: #fff;"> View Exam Objective</h3>
    <button mat-icon-button (click)="close()" class="text-white">
        <mat-icon>close</mat-icon>
    </button>
</mat-dialog-actions>
<mat-dialog-content class="dark-bg  dark-mode">
    <div class="row mt-1">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Certification Title</h4>
            <div class="text-white">{{data?.certification?.certificationTitle}}</div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Domain Name</h4>
            <div class="text-white">{{data?.domain?.domainName}}</div>
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Target Objective Name</h4>
            <div class="text-white">{{data.objective?.objectiveName}}</div>
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-12">
            <h4 class="text-color-black-normal-50 label-text">Exam objective terms *</h4>
            <div class="text-white" [innerHTML]="data.objective?.term"></div>
        </div>
    </div>


</mat-dialog-content>
<mat-dialog-actions  class="p-4 justify-content-end dark-bg dark-mode">
    <button class="edit-button" mat-raised-button (click)="editObjective()">Edit </button>
</mat-dialog-actions>
